import { AppConfig } from '@interfaces'
import { api } from '@utils/api/api'

export async function getAppConfig(isTester: boolean): Promise<AppConfig> {
  return api.get(
    `/api/v1/config?accessLevel=${isTester ? 'beta' : 'user'}`,
    true,
  )
}
